/**
 * Skyframe Frame Color Swatches
 * Adds data attributes to Frame Color variant buttons for swatch styling
 */

(function() {
  'use strict';
  
  function initializeFrameSwatches() {
    // Find all Frame Color variant option labels
    const frameLabels = document.querySelectorAll('.product-form__input label[for*="Frame"]');
    
    frameLabels.forEach(label => {
      // Get the frame color text from the label
      const frameText = label.textContent.trim().replace(/\s+/g, ' ');
      
      // Add data attribute for CSS targeting
      label.setAttribute('data-frame', frameText);
    });
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFrameSwatches);
  } else {
    initializeFrameSwatches();
  }
  
  // Re-initialize when product changes (for quick view, AJAX, etc.)
  document.addEventListener('shopify:section:load', initializeFrameSwatches);
  
})();
